export { default } from './comment-question'
